import React, { useState } from 'react';
import { GlobeIcon, CheckIcon, ChevronDownIcon } from 'lucide-react';
const languages = [{
  code: 'en',
  name: 'English',
  flag: '🇺🇸'
}, {
  code: 'es',
  name: 'Español',
  flag: '🇪🇸'
}, {
  code: 'fr',
  name: 'Français',
  flag: '🇫🇷'
}, {
  code: 'de',
  name: 'Deutsch',
  flag: '🇩🇪'
}, {
  code: 'pt',
  name: 'Português',
  flag: '🇵🇹'
}, {
  code: 'it',
  name: 'Italiano',
  flag: '🇮🇹'
}];
export function LanguageSelector() {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(languages[0]);
  const toggleDropdown = () => setIsOpen(!isOpen);
  const selectLanguage = language => {
    setSelectedLanguage(language);
    setIsOpen(false);
  };
  return <div className="relative" data-id="element-3429">
      <button onClick={toggleDropdown} className="flex items-center p-2 rounded-lg text-blue-300 hover:text-white hover:bg-white/10 transition-colors" data-id="element-3430">
        <GlobeIcon size={18} className="mr-2" data-id="element-3431" />
        <span className="mr-1" data-id="element-3432">{selectedLanguage.flag}</span>
        <span className="hidden md:inline" data-id="element-3433">
          {selectedLanguage.code.toUpperCase()}
        </span>
        <ChevronDownIcon size={16} className="ml-1" data-id="element-3434" />
      </button>
      {isOpen && <div className="absolute right-0 mt-2 w-48 bg-gradient-to-br from-slate-800 to-blue-900 rounded-lg shadow-lg overflow-hidden z-50 border border-white/10" data-id="element-3435">
          <div className="py-1" data-id="element-3436">
            {languages.map(language => <button key={language.code} className="flex items-center w-full px-4 py-2 text-sm text-white hover:bg-white/10 transition-colors" onClick={() => selectLanguage(language)} data-id="element-3437">
                <span className="mr-2" data-id="element-3438">{language.flag}</span>
                <span className="flex-1 text-left" data-id="element-3439">{language.name}</span>
                {selectedLanguage.code === language.code && <CheckIcon size={16} className="text-blue-400" data-id="element-3440" />}
              </button>)}
          </div>
        </div>}
    </div>;
}